module.exports = __webpack_public_path__ + "static/img/duoduohello.6fb8cf5.png";


//////////////////
// WEBPACK FOOTER
// ./static/imgs/duoduohello.png
// module id = UyuX
// module chunks = 173